"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSearchWrapper = exports.StyledDropdownContentBlock = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _card = _interopRequireDefault(require("@ux/card"));
var _core = require("@linaria/core");
const intents = new _intents.default();
const StyledSearchWrapper = exports.StyledSearchWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StyledSearchWrapper",
  class: "sd89101",
  vars: {
    "sd89101-0": [props => props.styling?.width || '100%'],
    "sd89101-1": [props => String(props.styling?.buttonColorHover)],
    "sd89101-2": [props => String(props.styling?.backgroundColor)],
    "sd89101-3": [props => String(props.styling?.border)],
    "sd89101-5": [props => String(props.styling?.borderRadius)],
    "sd89101-7": [props => String(props.styling?.buttonRadius ? props.styling?.buttonRadius : props.styling?.borderRadius)],
    "sd89101-8": [props => String(props.styling?.buttonRadius ? props.styling?.buttonRadius : props.styling?.borderRadius)],
    "sd89101-9": [props => String(props.styling?.buttonMargin)],
    "sd89101-10": [props => String(props.styling?.buttonColor)],
    "sd89101-12": [props => String(props.styling?.buttonBorder)],
    "sd89101-13": [props => String(props?.voiceButtonStyling?.buttonColor)],
    "sd89101-14": [props => String(props?.voiceButtonStyling?.buttonColorHover)],
    "sd89101-15": [props => String(props?.voiceButtonStyling?.buttonBorder)],
    "sd89101-17": [props => String(props.styling?.height)],
    "sd89101-19": [props => String(props.styling?.fontSize)]
  }
});
const {
  StyledDropdownContentBlock
} = getStyled();
exports.StyledDropdownContentBlock = StyledDropdownContentBlock;
function getStyled() {
  return {
    StyledDropdownContentBlock: /*#__PURE__*/(0, _react.styled)(_card.default)({
      name: "StyledDropdownContentBlock",
      class: "s1rzs4d3"
    })
  };
}
"d1ccpqpd";